var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlighter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.844978 20.6773C3.67699 22.1086 3.58212 22.0822 3.69314 22.0822C3.86673 22.0822 3.7981 22.1046 5.35036 20.5352C6.57157 19.3008 8.51341 19.2704 9.77298 20.4682C10.1525 20.8296 9.93244 20.9108 22.4252 6.7905C23.059 6.07383 23.0287 4.98156 22.3566 4.30143L18.9472 0.854089C18.2751 0.17396 17.1911 0.143507 16.4806 0.785062C2.67176 13.273 2.59505 13.1898 2.95233 13.5715C4.13722 14.8465 4.10896 16.8117 2.88572 18.0482L0.766255 20.1921C0.62092 20.3383 0.661291 20.586 0.844978 20.6793V20.6773ZM18.5173 1.28247L21.9266 4.72981C22.3727 5.18052 22.3929 5.90735 21.971 6.38445L11.2445 18.509L4.88811 12.0833L16.8843 1.23577C17.3546 0.811455 18.0712 0.831757 18.5153 1.28247H18.5173ZM4.45211 12.5036C4.45211 12.4833 4.42183 12.4731 10.8327 18.9536L9.96676 19.8287C8.48515 18.6207 6.35559 18.7039 4.96885 20.0581L3.36008 18.4319C4.70039 17.031 4.78315 14.8749 3.58615 13.3786L4.45211 12.5036ZM2.93417 18.8643C2.93417 18.844 2.92811 18.8582 4.54294 20.4905L3.6346 21.4082L1.49091 20.3241L2.93417 18.8643Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.489605
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlighter);
export default __webpack_public_path__ + "static/media/Highlighter.4513c6b365c94625f81f51256d9903a2.svg";
export { ForwardRef as ReactComponent };